/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";

export class IceIceYetiGameAssets {

    public static INTRO_BACKGROUND:string = "introSplash";
    public static LOGO:string = "logo";
    public static LOGO_SHADOW:string = "logoShadow";
    public static LOGO_YETI:string = "logo_yeti-reflection";
    public static WINWAYS:string = "introSplash-winways";
    public static MAIN_GAME_BACKGROUND_LANDSCAPE:string = "main_landscape_background";
    public static RESPIN_BACKGROUND_LANDSCAPE:string = "respin_landscape_background";
    public static MAIN_GAME_TOP_FOREGROUND:string = "foreground/foreground_top";
    public static MAIN_GAME_BOTTOM_FOREGROUND:string = "foreground/foreground_bottom";
    public static MAIN_GAME_BOTTOM_FOREGROUND_LEFT:string = "foreground/foreground_bottom_left";
    public static MAIN_GAME_BOTTOM_FOREGROUND_RIGHT:string = "foreground/foreground_bottom_right";
    public static RESPIN_TOP_FOREGROUND:string = "foreground/respin_foreground_top";
    public static RESPIN_BOTTOM_FOREGROUND:string = "foreground/respin_foreground_bottom";
    public static RESPIN_BOTTOM_FOREGROUND_LEFT:string = "foreground/respin_foreground_bottom_left";
    public static RESPIN_BOTTOM_FOREGROUND_RIGHT:string = "foreground/respin_foreground_bottom_right";
    public static REEL_BACKGROUND_IMAGE:string = "reel_background/background_rock";
    public static REEL_BACKGROUND_RESPIN_IMAGE:string = "reel_background/background_rock_fs";
    public static BIG_WIN_TEXT_LEVEL_01:string = "bigWin/bw_level_animation/bw_lvl1_";
    public static BIG_WIN_TEXT_LEVEL_02:string = "bigWin/bw_level_animation/bw_lvl2_";
    public static BIG_WIN_TEXT_LEVEL_03:string = "bigWin/bw_level_animation/bw_lvl3_";
    public static BIG_WIN_YETI:string = "bigWin/bw_yeti/bw_yeti_";

    //Frames
    public static WIN_FRAME:string = "winFrame/win_present_";

    //Animations
    public static WILD_PRESENTATION_01:string = "W/wildPresentation/01/W1_yeti_";
    public static WILD_PRESENTATION_02:string = "W/wildPresentation/02/W2_yeti_";
    public static REEL_ATTENTION:string = "reelAttention/reelAttention";
    public static SMALL_WIN:string = "small_win/small_win_";
    public static MEDIUM_WIN:string = "medium_win/medium_win_";
    public static LARGE_WIN:string = "large_win/large_win_";
    public static BIG_WIN_EXPLOSION:string = "big_win_explosion/bigWinExplosion_";
    public static GENERAL_SYMBOL_FREEZE:string = "freezeFX/freezefx_";
    public static WILD_EXCITEMENT:string = "iceForExcitement/ice_reveal";
    public static YETI_SNEEZE:string = "bigWin/yeti_sneeze/sneeze_";
    public static BIG_WIN_TEXT_HIT:string = "bigWin/bw_text_hit/bwtext_hit_";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt")
                ]
            },
            {
                name : "intro",
                assets : [
                    new TextureAsset(IceIceYetiGameAssets.INTRO_BACKGROUND, "sheets/introJpeg/introSplash.jpg"),
                    new TextureAsset(IceIceYetiGameAssets.LOGO_SHADOW, "sheets/introJpeg/logoShadow.jpg"),
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ]
            }
        ],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset("yetiCountUp", "fonts/bitmapfonts/yetiCountUp.fnt")
                ]
            },
            {
                name : "mainHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset(IceIceYetiGameAssets.MAIN_GAME_BACKGROUND_LANDSCAPE, "sheets/mainJpeg/main_landscape_background.jpg"),
                    new TextureAsset(IceIceYetiGameAssets.RESPIN_BACKGROUND_LANDSCAPE, "sheets/mainJpeg/respin_landscape_background.jpg")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset(IceIceYetiGameAssets.MAIN_GAME_TOP_FOREGROUND, "sheets/images/foreground/foreground_top.png"),
                    new TextureAsset(IceIceYetiGameAssets.MAIN_GAME_BOTTOM_FOREGROUND_LEFT, "sheets/images/foreground/foreground_bottom_left.png"),
                    new TextureAsset(IceIceYetiGameAssets.MAIN_GAME_BOTTOM_FOREGROUND_RIGHT, "sheets/images/foreground/foreground_bottom_right.png"),
                    new TextureAsset(IceIceYetiGameAssets.RESPIN_TOP_FOREGROUND, "sheets/images/foreground/respin_foreground_top.png"),
                    new TextureAsset(IceIceYetiGameAssets.RESPIN_BOTTOM_FOREGROUND_LEFT, "sheets/images/foreground/respin_foreground_bottom_left.png"),
                    new TextureAsset(IceIceYetiGameAssets.RESPIN_BOTTOM_FOREGROUND_RIGHT, "sheets/images/foreground/respin_foreground_bottom_right.png"),
                    new TextureAsset(IceIceYetiGameAssets.REEL_BACKGROUND_IMAGE, "sheets/images/reel_background/background_rock.png"),
                    new TextureAsset(IceIceYetiGameAssets.REEL_BACKGROUND_RESPIN_IMAGE, "sheets/images/reel_background/background_rock_fs.png"),
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json"),
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json")
                ],
                animations : {
                    "snow0" : "particles/Snow10",
                    "snow1" : "particles/flake01/flake01_",
                    "snow2" : "particles/flake02/flakes02_",
                    "snow3" : "particles/flake03/flake03_",
                    "button" : "ui/button/button",
                    "button-disabled" : "ui/button/button-disabled"
                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsHigh010", "sheets/symbolsHigh01/symbolsHigh010.json"),
                    new TextureAsset("symbolsHigh020", "sheets/symbolsHigh02/symbolsHigh020.json"),
                    new TextureAsset("symbolsHigh021", "sheets/symbolsHigh02/symbolsHigh021.json"),
                    new TextureAsset("symbolsHigh022", "sheets/symbolsHigh02/symbolsHigh022.json"),
                    new TextureAsset("symbolsLow0", "sheets/symbolsLow/symbolsLow0.json")
                ],
                animations : {
                    L1_normal : "L1/L1",
                    L2_normal : "L2/L2",
                    L3_normal : "L3/L3",
                    L4_normal : "L4/L4",
                    L5_normal : "L5/L5",
                    M1_normal : "M1/M1",
                    M2_normal : "M2/M2",
                    M3_normal : "M3/M3",
                    M4_normal : "M4/M4",
                    W_normal : "W/W",

                    L1_spin : "L1/L1_spin",
                    L2_spin : "L2/L2_spin",
                    L3_spin : "L3/L3_spin",
                    L4_spin : "L4/L4_spin",
                    L5_spin : "L5/L5_spin",
                    M1_spin : "M1/M1_spin",
                    M2_spin : "M2/M2_spin",
                    M3_spin : "M3/M3_spin",
                    M4_spin : "M4/M4_spin",
                    W_spin : "W/W_spin",
                    W_spinNearWin : "W/wildNearWin/W_land",
                    W_spinNearWinGlow : "W/wildNearWin/W_spin_nearwin",
                    W_spinNearWinParticles : "W/wildNearWin/particles/W_land_particles_",

                    L1_win : "L1/L1_win/L1_win_",
                    L2_win : "L2/L2_win/L2_win_",
                    L3_win : "L3/L3_win/L3_win_",
                    L4_win : "L4/L4_win/L4_win_",
                    L5_win : "L5/L5_win/L5_win_",
                    M1_win : "M1/M1_win/M1_win_",
                    M2_win : "M2/M2_win/M2_win_",
                    M3_win : "M3/M3_win/M3_win_",
                    M4_win : "M4/M4_win/M4_win_",
                    W_win : "W/W_win/W_win_",

                    L1_freeze : "L1/L1_freeze_",
                    L2_freeze : "L2/L2_freeze_",
                    L3_freeze : "L3/L3_freeze_",
                    L4_freeze : "L4/L4_freeze_",
                    L5_freeze : "L5/L5_freeze_",
                    M1_freeze : "M1/M1_freeze_",
                    M2_freeze : "M2/M2_freeze_",
                    M3_freeze : "M3/M3_freeze_",
                    M4_freeze : "M4/M4_freeze_",
                    W_freeze : "W/W_freeze_",

                    L1_frozen : "L1/L1_frozen",
                    L2_frozen : "L2/L2_frozen",
                    L3_frozen : "L3/L3_frozen",
                    L4_frozen : "L4/L4_frozen",
                    L5_frozen : "L5/L5_frozen",
                    M1_frozen : "M1/M1_frozen",
                    M2_frozen : "M2/M2_frozen",
                    M3_frozen : "M3/M3_frozen",
                    M4_frozen : "M4/M4_frozen",
                    W_frozen : "W/W_frozen",

                    M1_land : "M1/M1_land/M1_land_",
                    M2_land : "M2/M2_land/M2_land_",
                    M3_land : "M3/M3_land/M3_land_",
                    M4_land : "M4/M4_land/M4_land_",
                    W_land : "W/wildLand/W_land_",

                    W_attentionInIce : "W/wildAttention/wildAtten_"
                }
            }
        ]
    };
}